import { render, staticRenderFns } from "./promotionOffice.vue?vue&type=template&id=35ed32c0&"
import script from "./promotionOffice.vue?vue&type=script&lang=js&"
export * from "./promotionOffice.vue?vue&type=script&lang=js&"
import style0 from "./promotionOffice.vue?vue&type=style&index=0&id=35ed32c0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports